import { Card, CardContent } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import React from "react";
import noise from "@/assets/noise.png";
import Image from "next/image";
import ctaLeftShape from "@/assets/mental-health-left-shape.svg";
import ctaRightShape from "@/assets/mental-health-right-shape.svg";

type Props = {
  data: Simplify<Content.CallToActionCardSliceMentalWellbeingCtaPrimary>;
};

export default function MentalHealthCta({ data }: Props) {
  return (
    <Card className="shadow-none border-none bg-[#045B91] text-white py-10 relative overflow-hidden lg:px-20 xl:px-40">
      <div
        className="absolute inset-0 h-full w-full mix-blend-overlay opacity-[0.4]"
        style={{
          background: `url(${noise.src}) lightgray 0% 0% / 60.90909242630005px 60.90909242630005px repeat`,
        }}
      />
      <CardContent className="py-6">
        <PrismicRichText
          field={data.content}
          components={{
            paragraph: ({ children }) => (
              <p className="text-2xl font-bold text-center">{children}</p>
            ),
          }}
        />
      </CardContent>

      <Image
        src={ctaLeftShape.src}
        alt=""
        width={543}
        height={502}
        className="absolute top-0 -left-40 md:-left-20 h-96 pointer-events-none"
      />

      <Image
        src={ctaRightShape.src}
        alt=""
        width={543}
        height={502}
        className="absolute top-0 -right-40 md:-right-20 h-96 pointer-events-none"
      />
    </Card>
  );
}
